module.exports = __webpack_public_path__ + "img/avatar3.8e374d31.png";